import React from "react";
import OrdersListItem from "../../OrdersListItem";

const ViewOrderList = (props) => {
    const { data } = props;
    return (
        <ul className="tab-content unlimited-block tab-content1 items-list orders-list">
            {data.order.results.map(elem =>
                <OrdersListItem
                    key={elem.id}
                    {...elem}
                />
            )}
        </ul>
    )
}

export default ViewOrderList;


// WEBPACK FOOTER //
// ./src/components/Orders/SubComponentsRightContent/ViewOrderList.js